import { Grid } from '@mui/material';
import React from 'react';
import { WsTypography, WsTypoColors, WsTagsList, ChipsType } from 'wisestep-base';
interface ActionsFiltersWithTitleProps {
  recruiterActions: string[] | undefined;
  candidateResponses: string[] | undefined;
}

const ActionsFiltersWithTitle = ({
  recruiterActions,
  candidateResponses,
}: ActionsFiltersWithTitleProps) => (
  <Grid container mt={2}>
    {recruiterActions && recruiterActions?.length > 0 && (
      <Grid container item xs={12} alignItems="center">
        <WsTypography color={WsTypoColors.SENARY}>Recruiter Actions : </WsTypography>
        <WsTagsList chipArray={recruiterActions} count={4} type={ChipsType.SECONDARY} />
      </Grid>
    )}
    {candidateResponses && candidateResponses?.length > 0 && (
      <Grid container item xs={12} alignItems="center">
        <WsTypography color={WsTypoColors.SENARY}>Candidate&apos;s Actions :</WsTypography>
        <WsTagsList chipArray={candidateResponses} count={4} type={ChipsType.SECONDARY} />
      </Grid>
    )}
  </Grid>
);

export default ActionsFiltersWithTitle;
